<div class="card card-p2p mb-3 cursor--pointer" (click)="openP2PDetailsPage(peerToPeer.id ,$event)">
    <div class="card-body card-body--p2p">
        <div class="d-flex">
            <div class="d-block">
                <img [src]="image" alt="Peer To Peer Campaign Image" class="img-fluid rounded-start" style="height: 110px; min-width: 220px; border-radius: 4px;">
            </div>
            <div class="d-flex flex-column justify-content-between w-100 ml-4">
                <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center">
                        <h5 class="subtitle-1--weight-regular mb-0">{{peerToPeer.name}}</h5>
                        <i class="fas fa-chevron-right ml-2" style="color: #000000;"></i>
                    </div>
                    <div class="d-block">
                        <div class="d-flex align-items-center">
                            @for (img of p2pDonorImages; track img.id; let index = $index) {
                                @if(index < 5) {
                                    <img [src]="img.imageUrl" alt="img" class="p2p-row-image">
                                }
                            }

                            @if(p2pDonorImages.length > 5) {
                                <span class="p2p-row-image-text ml-1">+{{p2pDonorImages.length - 5}}</span>
                            }
                        </div>
                    </div>
                </div>
                <div class="d-block">
                    <div class="d-flex justify-content-between">
                        <span class="body-2 pl-1 mt-auto">
                            <span class="of-text">Raised</span> {{raised | currency:'USD':'symbol-narrow':'1.0-0'}}
                                
                            @if(peerToPeer.campaignTypeData.goal !== 0) {
                                <span class="of-text">of </span> 
                                <span class="p2p-goal-text">{{peerToPeer.campaignTypeData.goal | currency:'USD':'symbol-narrow':'1.0-0'}}</span>
                            }
                        </span>

                        <ul class="d-flex flex-row justify-content-end actions-list list-group mb-2" style="height: 36px;" >
                            @if (pledgePerEvent) {
                                <li (click)="onClickFulfillBulkPledges($event)" class="list-group-item d-flex px-2 mr-2">
                                    <i class="fas fa-money-check-alt pointer"></i>
                                    <span class="ml-2 pointer expanded-text body-1 ">Fulfill Bulk Pledges</span>
                                </li>
                                
                                <li (click)="onClickAddBulkMilestones($event)" class="list-group-item d-flex px-2 mr-2">
                                    <i class="fas fa-running pointer"></i>
                                    <span class="ml-2 pointer expanded-text body-1">Add Bulk Milestones</span>
                                </li>
                            }

                            <li (click)="onClickCreate($event)"
                                class="list-group-item d-flex px-2 mr-2">
                                <i class="fas fa-plus pointer"></i>
                                <span class="ml-2 pointer expanded-text body-1 ">Create Fundraiser</span>
                            </li>
                            <li (click)="onClickImport($event)"
                                class="list-group-item d-flex px-2 mr-2">
                                <i class="fas fa-arrow-up pointer"></i>
                                <span class="ml-2 pointer expanded-text body-1 ">Import Fundraisers</span>
                            </li>
                            <li (click)="onClickDownloadQRCards($event)"
                                class="list-group-item d-flex px-2 mr-2">
                                <i class="fas fa-arrow-down pointer"></i>
                                <span class="ml-2 pointer expanded-text body-1 ">Download QR Fundraisers Cards</span>
                            </li>
                            <li (click)="onClickNotifyAll($event)"
                                class="list-group-item d-flex px-2 mr-2">
                                <i class="fas fa-bell pointer"></i>
                                <span class="ml-2 pointer expanded-text body-1 ">Notify All</span>
                            </li>
                        </ul> 
                    </div>
                    
                    <div class="progress md-progress p2p-progress mt-2"
                        [innerHTML]="progressBarHtml">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>